export const PROGRAM_OBPS = 'OBPS';
export const PROGRAM_CFR = 'CFR';
export const PROGRAM_OFFSET = 'OFFSET';
